/* ============================================================================
   §5.1 · Announcement bar rotation.
   ========================================================================= */
(function () {
  'use strict';

  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('[data-announce-msg]');
    if (msgs.length < 2) return;

    var interval = parseInt(bar.dataset.interval, 10) || 5000;
    var index = 0;
    var timer = null;

    function show(next) {
      msgs.forEach(function (m, i) {
        var on = i === next;
        m.classList.toggle('is-active', on);
        if (on) m.removeAttribute('aria-hidden');
        else m.setAttribute('aria-hidden', 'true');
      });
      index = next;
    }

    function start() {
      // A rotating bar that keeps cycling in a background tab is pure battery
      // cost — nobody is reading it.
      if (timer || still.matches || document.hidden) return;
      timer = setInterval(function () {
        show((index + 1) % msgs.length);
      }, interval);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    // Reduced motion leaves message one permanently visible rather than
    // crossfading slower — the transition IS the thing being opted out of.
    still.addEventListener('change', function () {
      if (still.matches) stop();
      else start();
    });

    start();
  });
})();
